// extracted by mini-css-extract-plugin
export var askAiIcon = "_mh-j";
export var category = "_mh-9";
export var categoryHeader = "_mh-e";
export var container = "_mh-0";
export var group = "_mh-a";
export var groupItems = "_mh-f";
export var groupSeparator = "_mh-k";
export var loading = "_mh-1";
export var noResults = "_mh-3";
export var placeholder = "_mh-2";
export var resultContent = "_mh-5";
export var resultIcon = "_mh-c";
export var resultItem = "_mh-g";
export var resultMeta = "_mh-8";
export var resultSubtitle = "_mh-7";
export var resultSuffix = "_mh-i";
export var resultTitle = "_mh-6";
export var resultsList = "_mh-4";
export var searchGroup = "_mh-d";
export var selected = "_mh-h";
export var subgroup = "_mh-b";